import { useCallback, useContext, useState } from 'react'
import { v4 } from 'uuid'

import { ReplicacheContext } from '../../providers/ReplicacheProvider/ReplicacheProvider'
import { addNewInspectionMedia } from '../../replicache/dviMedia/addNewInspectionMedia'
import { deleteInspectionMedia } from '../../replicache/dviMedia/deleteInspectionMedia'
import { InspectionMediaEntry } from '../../sdk'
import EditMediaDialog from './EditMediaDialog'

export const EditMediaButtonCached = ({
  mediaEntry,
  parentId,
  inspectionId,
  url
}: {
  parentId: string
  mediaEntry: InspectionMediaEntry
  inspectionId: string
  url: string
}) => {
  const { replicacheInstance } = useContext(ReplicacheContext)
  const [open, setOpen] = useState(false)

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])
  const handleDelete = useCallback(() => {
    deleteInspectionMedia(
      {
        id: mediaEntry.id!,
        info: {
          ...mediaEntry!.info!,
          archived: new Date()
        }
      },
      inspectionId,
      replicacheInstance
    )
    handleClose()
  }, [handleClose, inspectionId, mediaEntry, replicacheInstance])

  const handleUpdate = useCallback(
    (fileBlob: Blob) => {
      deleteInspectionMedia(
        {
          id: mediaEntry.id!,
          info: {
            ...mediaEntry!.info!,
            archived: new Date()
          }
        },
        inspectionId,
        replicacheInstance
      )
      const id = v4()
      const newMediaEntry: InspectionMediaEntry = {
        id,
        mediaUrl: '',
        thumbnailUrl: '',
        info: {
          ...mediaEntry.info!
        }
      }
      addNewInspectionMedia(
        fileBlob,
        newMediaEntry,
        inspectionId,
        replicacheInstance
      )
      handleClose()
    },
    [handleClose, inspectionId, mediaEntry, replicacheInstance]
  )

  return (
    <>
      <button hidden onClick={() => setOpen(true)}></button>
      {open && (
        <EditMediaDialog
          {...{
            mediaEntry,
            url,
            parentId,
            handleDelete,
            handleUpdate,
            handleClose
          }}
        />
      )}
    </>
  )
}
